import axios from "axios";

const apiCEP = axios.create({
    baseURL: "https://ws.apicep.com/",
    //"https://api.infosimples.com/api/v2/consultas/correios/",
});

export default apiCEP;
